const API_URL = `${process.env.REACT_APP_BACKEND_URL}`

export const API_ROUTES = {
  PC: `${API_URL}/api/pc`,
  SIGN_IN: `${API_URL}/api/auth/login`,
  TOKEN_CHECK: `${API_URL}/api/auth/tokenCheck`,
  FEATURED_PC: `${API_URL}/api/featuredpc`
}